module.exports = __webpack_public_path__ + "static/media/Capacidad60-media.d7eef3ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/Capacidad60-media.svg
// module id = 153
// module chunks = 0